<template>
    <div>
        <div class="timer">{{currentTime}}/{{durationTime}}</div>
        <!-- slider -->
        <div class="slider" ref="slider">
            <div class="dot"
                 ref="dot"
                 :style="{marginLeft:dotMarginLeft}"
                 @touchstart="onDotMousedown($event)"
                 @touchmove="onDotMousemove($event)"
                 @touchend="onDotMouseup($event)"
            ></div>
            <div class="bar-wrap" @click="onBarClick($event)">
                <div class="bar" :style="{width:`${percentage}%`}"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PlayerSlider",
    props:{
        playerStatus:{
            type:Object,
            require:true,
        }
    },
    computed:{
        /** 计算当前播放百分比 */
        percentage(){
            if(this.dotTouching){
                const sliderWidth = this.$refs.slider.clientWidth
                return this.dotTouchingX / sliderWidth * 100
            }
            const status = this.playerStatus
            return status.current / status.duration * 100
        },
        /** 计算控制按钮偏移量 */
        dotMarginLeft(){
            return `calc(${this.percentage}% - 10px)`
        },
        durationTime(){
            return this.realFormatSecond(this.playerStatus.duration)
        },
        currentTime(){
            if(this.dotTouching){
                const t = this.percentage / 100 * this.playerStatus.duration
                return this.realFormatSecond(t)
            }
            return this.realFormatSecond(this.playerStatus.current)
        }
    },
    data(){
        return{
            dotTouching:false,
            dotTouchingX:0,
        }
    },
    methods:{
        realFormatSecond(second) {
            let secondType = typeof second

            if (secondType === 'number' || secondType === 'string') {
                second = parseInt(second)

                let mimute = Math.floor(second / 60)
                second = second - mimute * 60

                return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
            } else {
                return '00:00'
            }
        },
        onBarClick(e){
            const x = e.offsetX // 当前位置距离元素左侧多少像素
            const width = this.$refs.slider.clientWidth // 元素宽度
            const percentage = x / width * 100
            this.$emit('change',percentage)
        },
        onDotMousedown(e){
            e.preventDefault()
        },
        onDotMousemove(e){
            // 鼠标所在位置
            let clientX
            this.dotTouching = true
            if(e.touches){
                const t = e.touches[0]
                clientX = t.clientX
            }else{
                clientX = e.clientX
            }
            // 进度条起始位置
            const sliderStartX = this.$refs.slider.offsetLeft
            // 进度条宽度
            const sliderWidth = this.$refs.slider.clientWidth
            // 目标位置
            const targetX = clientX - sliderStartX - 10;
            // 超出进度条，直接return
            if(targetX > sliderWidth){
                this.dotTouchingX = sliderWidth
                return
            }else if(targetX < -10){
                this.dotTouchingX = -10
                return
            }
            this.dotTouchingX = targetX
        },
        onDotMouseup(){
            this.$emit('change',this.percentage)
            this.dotTouching = false
        },
    },

}

</script>

<style scoped>
.timer{
    color: #eee;
    text-align: center;
    margin-bottom: 2vw;
}
.slider{
    position: relative;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.dot{
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background-color: #ebedf0;
    box-shadow: 0 1px 2px rgba(0,0,0,0.5);
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
}
.bar-wrap{
    background-color: #ebedf0;
    height: 2px;
    width: 100%;
    border-radius: 1px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.3);
}
.bar{
    height: 2px;
    background-color: #1989fa;
}
</style>
